import type { SnackbarOrigin } from '@mui/material/Snackbar';
import { create } from 'zustand';

interface AlertState {
  message: string | null;
  severity: 'success' | 'error' | 'warning' | 'info';
  visible: boolean;
  autoHideDuration: number | null;
  linkUrl: string | null;
  position: SnackbarOrigin;
  showAlert: (
    message: string,
    severity: 'success' | 'error' | 'warning' | 'info',
    autoHideDuration?: number | null,
    linkUrl?: string | null,
    position?: SnackbarOrigin,
  ) => void;
  hideAlert: () => void;
}

const DEFAULT_AUTO_HIDE_DURATION = 6000;
// Default anchor for all alerts. Only campaign toasts override this per-call;
// every other showAlert() caller keeps top-center.
const DEFAULT_POSITION: SnackbarOrigin = { vertical: 'top', horizontal: 'center' };

const useAlertStore = create<AlertState>((set) => ({
  message: null,
  severity: 'info',
  visible: false,
  autoHideDuration: DEFAULT_AUTO_HIDE_DURATION,
  linkUrl: null,
  position: DEFAULT_POSITION,
  showAlert: (
    message,
    severity,
    autoHideDuration = DEFAULT_AUTO_HIDE_DURATION,
    linkUrl = null,
    position = DEFAULT_POSITION,
  ) => set({ message, severity, visible: true, autoHideDuration, linkUrl, position }),
  // Reset position on hide so a campaign toast's bottom-right can't leak onto a
  // later top-center alert.
  hideAlert: () => set({ visible: false, message: null, linkUrl: null, position: DEFAULT_POSITION }),
}));

export default useAlertStore;
